import { Injectable } from '@angular/core';
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";

import { FeeConfig, UpdatedFeeRequest } from "../models/fee.model";

@Injectable({
  providedIn: 'root'
})
export class FeeAdministrationService {

	constructor(private client: HttpClient) { }


	getFeeConfiguration(): Observable<FeeConfig[]> {
		return this.client.get<FeeConfig[]>("/api/admin/get-fee-configuration");
	}	

	updateFeeConfiguration(updates: UpdatedFeeRequest[]): Observable<FeeConfig[]> {
		return this.client.post<FeeConfig[]>("/api/admin/update-fee-configuration", updates);
	}
}
